export function lastCharInStringIsPeriod(str: string): boolean {
  return /\.$/.test(str.trim());
}
